import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { UserService } from 'src/app/services/user/user.service';
import { GrnService } from 'src/app/services/grn/grn.service';

@Component({
  selector: 'app-grnlist',
  templateUrl: './grnlist.component.html',
  styleUrls: ['./grnlist.component.css']
})
export class GrnlistComponent implements OnInit {

  data: any;
  pono: string;

  isUserSiteinc: boolean;
  isUserTransport: boolean;

  constructor(private grnservice: GrnService, private router: Router,
    private route: ActivatedRoute, private userService: UserService) { }

  ngOnInit() {
    this.Getgrnheader();
  }
  Getgrnheader() {
    debugger;
    this.grnservice.GetGrnHeaderList().subscribe(
      data => {
        this.data = data;
        console.log(data);
      }
    )

  }

  viewOrder(id) {
    debugger;
    // alert(id);
    this.router.navigate(['/grnform/' + id + '']);

    // this.engineeringservice.GetPurchaseline(id).subscribe(
    //   data => {
    //     this.data = data;
    //     console.log(data);
    //   })

  }
}
